/* Booking intent only. A click is never counted as a confirmed lead or booking. */
(() => {
  'use strict';
  if (window.zagoBookingInstalled) return;
  window.zagoBookingInstalled = true;
  const shopify = window.Shopify;
  if (!shopify || shopify.designMode || !shopify.theme || shopify.theme.role !== 'main') return;
  const measurementId = 'G-EETPC6L11P';
  const allowed = () => !!(shopify.customerPrivacy && shopify.customerPrivacy.analyticsProcessingAllowed());
  const consent = () => ({ analytics_storage: allowed() ? 'granted' : 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  function tag() {
    if (!window.zagoBookingTag) {
      window.zagoBookingLayer = [];
      window.zagoBookingTag = function () { window.zagoBookingLayer.push(arguments); };
      window.zagoBookingTag('consent', 'default', consent());
      window.zagoBookingTag('js', new Date());
      window.zagoBookingTag('config', measurementId, {
        send_page_view: false, allow_google_signals: false,
        allow_ad_personalization_signals: false,
        page_location: location.origin + location.pathname, page_referrer: ''
      });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId + '&l=zagoBookingLayer';
      document.head.appendChild(script);
    }
    return window.zagoBookingTag;
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor || !allowed()) return;
    let url;
    try { url = new URL(anchor.href, location.origin); } catch (_) { return; }
    const destination = url.origin + url.pathname.replace(/\/$/, '');
    const providers = {
      'https://calendly.com/shopifyexperts/30min': 'calendly',
      'https://meetings.hubspot.com/zago': 'hubspot'
    };
    const provider = providers[destination];
    if (!provider) return;
    tag()('event', 'booking_click', {
      send_to: measurementId, booking_provider: provider,
      link_url: destination,
      language: document.documentElement.lang,
      page_location: location.origin + location.pathname,
      page_referrer: '', transport_type: 'beacon'
    });
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (window.zagoBookingTag) window.zagoBookingTag('consent', 'update', consent());
  });
  if (!shopify.customerPrivacy && shopify.loadFeatures) {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
